// src/components/Modal/Modal.js
// src/components/Form/Modal.js
import React, { useId, useRef } from 'react';
import ReactModal from 'react-modal';
import { FaArrowRight, FaExclamationCircle, FaTimes } from 'react-icons/fa';
import './Modal.css'; // Estilos para o modal

const Modal = ({
  show, onClose, message, titulo = "Aviso", children, className = '',
  variante, onConfirm, onAfterClose
}) => {
  const tituloId = useId();
  const mensagemId = useId();
  const confirmarRef = useRef(null);

  if (variante === 'variacoes') {
    const appElement = document.getElementById('root');
    const mensagens = Array.isArray(message) ? message : [message];

    return (
      <ReactModal
        isOpen={show}
        onRequestClose={onClose}
        onAfterClose={onAfterClose}
        onAfterOpen={() => confirmarRef.current?.focus({ preventScroll: true })}
        appElement={appElement || undefined}
        ariaHideApp={Boolean(appElement)}
        aria={{ labelledby: tituloId, describedby: mensagemId, modal: true }}
        className="modal-variacoes"
        overlayClassName={'modal-overlay modal-variacoes-overlay' + (className ? ' ' + className : '')}
        bodyOpenClassName="modal-variacoes-aberto"
        htmlOpenClassName="modal-variacoes-aberto"
        shouldCloseOnOverlayClick={false}
        preventScroll
      >
        <button type="button" className="modal-variacoes-fechar" onClick={onClose} aria-label="Fechar aviso">
          <FaTimes aria-hidden="true" />
        </button>
        <div className="modal-variacoes-icone" aria-hidden="true"><FaExclamationCircle /></div>
        <h2 id={tituloId}>{titulo}</h2>
        <div id={mensagemId} className="modal-variacoes-mensagens">
          {mensagens.filter(Boolean).map((mensagem, indice) => <p key={indice}>{mensagem}</p>)}
        </div>
        <button ref={confirmarRef} type="button" className="modal-variacoes-confirmar" onClick={onConfirm}>
          Escolher opção <FaArrowRight aria-hidden="true" />
        </button>
      </ReactModal>
    );
  }

  if (!show) {
    return null;
  }

  return (
    <div className={`modal-overlay${className ? ` ${className}` : ''}`}>
      <div className="modal-content">
        <h2>{titulo}</h2>
        {message && (<p>{message}</p>)}
        
        {children ? children : (
          <button className="modal-button" onClick={onClose}>
          Fechar
          </button>
        )}
        
      </div>
    </div>
  );
};

export default Modal;
